import { addSlashes } from 'utils/cms/utils';
import { OVERRIDE } from 'utils/dynamicData';

function mapImages(cmsData) {
	const imageList = cmsData?.pages?.gallery?.images;
	if (!imageList) return {};

	// Then, map over the CMS images, overriding existing keys and adding new ones
	return Object.entries(imageList).reduce((acc, [id, item]) => {
		// Skip images without a URL
		if (!item?.url) return acc;
		acc[id] = {
			alt: item.alt || `${cmsData.title || 'Movie'} Gallery Image ${item.order + 1}`, // Provide default alt text if not set
			annotation: item.caption,
			desktopSrc: item.url,
			order: item.order,
		};
		return acc;
	}, { [OVERRIDE]: true });
}

export default function mapGallery(cmsData, appData) {
	if (!appData?.pages?.boltGallery) return null;

	const galleryData = cmsData?.pages?.gallery;
	if (!galleryData?.active) return null;

	return {
		disabled: false,
		data: {
			contentCarousel: mapImages(cmsData),
		},
		name: galleryData.name,
		order: cmsData.pages.home?.sections?.gallery?.order ?? galleryData.order,
		path: addSlashes(galleryData.path),
	};
}